import styled from "styled-components";

export const PageWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: left;
`;

export const ConfigFIeld = styled.section`
  font-size: 14px;
  display: grid;
  grid-template-columns: 300px auto;
  border-bottom: 1px solid black;
  margin: 3px 0;

  @media only screen and (max-width: 750px) {
    grid-template-columns: none;
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    border: 1px solid black;
    margin: 3px 0;
    padding: 2px 5px;
  }
`;

export const TituloConfig = styled.h3`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primaria};
`;
